import Svg from "./figs/Svg";

export default function CardManagePassenger({
  msg,
  tourTypeName,
  onClickDelete,
  isShowButtonAddCustomer,
  isShowButtonDelete,
  numOfAdult,
  numOfChild,
  numOfInfant,
  seatAvailable,
  boatCapacity,
  onClickAddCustomer,
  isShowFormAddCustomer,
  onClickCancel,
  onClickSubmit,
  nameNumOfAddAdult,
  nameNumOfAddChild,
  nameNumOfAddInfant,
  register,
  maxNumOfAddAdult = 100,
  maxNumOfAddChild = 100,
  maxNumOfAddInfant = 100,
}) {
  return (
    <div className="card_manage_passenger">
      <div>
        <div className="top_section">
          <div className="tour_type">{tourTypeName}</div>
          <div className="manage_customer">
            {isShowButtonAddCustomer && (
              <button
                className="button_add_customer"
                onClick={onClickAddCustomer}
              >
                {msg.add_customer}
              </button>
            )}
            {isShowButtonDelete && (
              <button onClick={onClickDelete} className="button_delete">
                <Svg iconName="delete_2" />
              </button>
            )}
            {isShowFormAddCustomer && (
              <div className="form_add_customer">
                <div>
                  <label>{msg["adult(s)"]}:</label>
                  <input
                    min={0}
                    max={maxNumOfAddAdult}
                    type="number"
                    {...register(nameNumOfAddAdult)}
                  />
                </div>
                <div>
                  <label>{msg["child(s)"]}:</label>
                  <input
                    min={0}
                    max={maxNumOfAddChild}
                    type="number"
                    {...register(nameNumOfAddChild)}
                  />
                </div>
                <div>
                  <label>{msg["infant(s)"]}:</label>
                  <input
                    min={0}
                    max={maxNumOfAddInfant}
                    type="number"
                    {...register(nameNumOfAddInfant)}
                  />
                </div>
                <div>
                  <button onClick={onClickCancel} className="_outline_button">
                    {msg.cancel}
                  </button>
                  <button onClick={onClickSubmit} className="_fill_button">
                    {msg.submit}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="num_of_passenger">
          {numOfAdult > 0 && (
            <div>
              <span>{`${msg["adult(s)"]}`}</span>
              <span>{`${numOfAdult} ${msg.pax}`}</span>
            </div>
          )}
          {numOfChild > 0 && (
            <div>
              <span>{`${msg["child(s)"]}`}</span>
              <span>{`${numOfChild} ${msg.pax}`}</span>
            </div>
          )}
          {numOfInfant > 0 && (
            <div>
              <span>{`${msg["infant(s)"]}`}</span>
              <span>{`${numOfInfant} ${msg.pax}`}</span>
            </div>
          )}
        </div>
      </div>
      <div className="bottom_section">
        <span>{msg.seat_available}</span>
        <span>
          <span className="total_of_passenger">{`${seatAvailable} ${msg.pax} `}</span>
          <span>{`/ ${boatCapacity} ${msg.pax}`}</span>
        </span>
      </div>
    </div>
  );
}
